module.exports = __webpack_public_path__ + "img/new-dfod-2.159300af.svg";